import { GetCuentasBancariasByFiltersDtoProps } from "./DTOs/GetCuentasBancariasByFiltersDto"
import { GetCuentasBancariasByIdQueryDtoProps } from "./DTOs/GetCuentasBancariasByIdQueryDto"
import { GetMovimientosPorConciliarAutomaticamenteDtoProps } from "./DTOs/GetMovimientosPorConciliarAutomaticamenteDto"
import { MovimientoBancarioReadingDtoProps } from "./DTOs/MovimientoBancarioReadingDto"

export const movimientosPorConciliarAutomaticamenteAdapter = (
  movimiento: GetMovimientosPorConciliarAutomaticamenteDtoProps
): GetMovimientosPorConciliarAutomaticamenteDtoProps => ({
  concepto: movimiento.concepto,
  deudorIban: movimiento.deudorIban,
  deudorNombre: movimiento.deudorNombre,
  documentoConciliado: movimiento.documentoConciliado,
  fecha: movimiento.fecha,
  idExterno: movimiento.idExterno,
  importe: movimiento.importe,
  importeConciliado: movimiento.importeConciliado,
  nota: movimiento.nota,
})

export const movimientosPorConciliarAdapter = (
  movimiento: MovimientoBancarioReadingDtoProps
): MovimientoBancarioReadingDtoProps => ({
  id: movimiento.id,
  balanceActual: movimiento.balanceActual,
  concepto: movimiento.concepto,
  conciliacionBancariaId: movimiento.conciliacionBancariaId,
  creditorNombre: movimiento.creditorNombre,
  deudorNombre: movimiento.deudorNombre,
  estadoConciliacion: movimiento.estadoConciliacion,
  fecha: movimiento.fecha,
  fechaValor: movimiento.fechaValor,
  idExterno: movimiento.idExterno,
  importe: movimiento.importe,
  importeConciliado: movimiento.importeConciliado,
  nota: movimiento.nota,
  status: movimiento.status,
  tipoConciliacion: movimiento.tipoConciliacion,
})

export const cuentaBancariaByIdApadater = (
  cuentaBancaria: GetCuentasBancariasByIdQueryDtoProps
): GetCuentasBancariasByIdQueryDtoProps => ({
  id: cuentaBancaria.id,
  bic: cuentaBancaria.bic,
  balanceDescuadrado: cuentaBancaria.balanceDescuadrado,
  cuentaContableEmpresaId: cuentaBancaria.cuentaContableEmpresaId,
  entidadBancaria: cuentaBancaria.entidadBancaria,
  estado: cuentaBancaria.estado,
  fechaRenovacion: cuentaBancaria.fechaRenovacion,
  fechaUltimaActualizacion: cuentaBancaria.fechaUltimaActualizacion,
  iban: cuentaBancaria.iban,
  identificadores: cuentaBancaria.identificadores,
  idExterno: cuentaBancaria.idExterno,
  logo: cuentaBancaria.logo,
  necesitaValidacion: cuentaBancaria.necesitaValidacion,
  nombre: cuentaBancaria.nombre,
  saldos: cuentaBancaria.saldos,
})

export const cuentaBancariaByFiltersApadater = (
  cuentaBancaria: GetCuentasBancariasByFiltersDtoProps
): GetCuentasBancariasByFiltersDtoProps => ({
  id: cuentaBancaria.id,
  balance: cuentaBancaria.balance,
  balanceDescuadrado: cuentaBancaria.balanceDescuadrado,
  estadoAutorizacionCuenta: cuentaBancaria.estadoAutorizacionCuenta,
  bic: cuentaBancaria.bic,
  cuentaContableEmpresaId: cuentaBancaria?.cuentaContableEmpresaId,
  entidadBancaria: cuentaBancaria.entidadBancaria,
  estado: cuentaBancaria.estado,
  fechaUltimaActualizacion: cuentaBancaria.fechaUltimaActualizacion,
  iban: cuentaBancaria.iban,
  identificadorExterno: cuentaBancaria.identificadorExterno,
  idExterno: cuentaBancaria.idExterno,
  identificadores: cuentaBancaria.identificadores,
  logo: cuentaBancaria.logo,
  necesitaValidacion: cuentaBancaria.necesitaValidacion,
  nombre: cuentaBancaria.nombre,
  saldos: cuentaBancaria.saldos,
})
